<template>
  <svg width="10" height="132" viewBox="0 0 10 132" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="10" height="132" fill="#0b3459" />
  </svg>
</template><script>
export default {};
</script>
